import React from 'react';

import './styles.scoped.css';

const EdgeReportingWindow = ({ windowContent, windowTitle, headerStyle, containerStyle }) => (
  <div>
    <div className="window-header" style={headerStyle}>
      {windowTitle}
    </div>
    <div className="window-container" style={containerStyle}>
      {windowContent}
    </div>
  </div>
);

export default EdgeReportingWindow;
